module.exports = __webpack_public_path__ + "img/12.0cde3097.jpg";